module.exports = __webpack_public_path__ + "static/media/WSOTE-BNB.501bcebb.svg";